import { render, staticRenderFns } from "./partnerDetailPage.vue?vue&type=template&id=cdb2bdc8&"
import script from "./partnerDetailPage.vue?vue&type=script&lang=ts&"
export * from "./partnerDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports